import { render, staticRenderFns } from "./Mechanics.vue?vue&type=template&id=7f9fc6ab"
import script from "./Mechanics.vue?vue&type=script&lang=js"
export * from "./Mechanics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports